import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Button } from '..';

const ConfirmDeleteModal = ({ description, onConfirm, onClick, confirmLabel = 'HAPUS', confirmColor = 'error' }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm(); // page handler: delete + toast + refresh; re-throws on error
      onClick(); // close on success (unmounts this component — no setState after)
    } catch (e) {
      setIsLoading(false); // failure: keep modal open, stop spinner
    }
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Typography variant="body1">{description}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Button color="color" variant="outlined" label="BATAL" fullWidth onClick={onClick} />
      </Grid>
      <Grid item xs={6}>
        <LoadingButton
          loading={isLoading}
          role="CircularProgress"
          color={confirmColor}
          variant="contained"
          fullWidth
          size="large"
          onClick={handleConfirm}
        >
          {confirmLabel}
        </LoadingButton>
      </Grid>
    </Grid>
  );
};

export default ConfirmDeleteModal;
